import { CompanyAPI } from '@api';

const getRoutesFromBus = (busId) => CompanyAPI.getRoutesFromBus({ busId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getRoutesFromBus };
